export default __webpack_public_path__ + "static/media/img_step_situation08.aa7c1453.jpg";